import { render } from "./NeedRefreshModal.vue?vue&type=template&id=b70810f6"
import script from "./NeedRefreshModal.vue?vue&type=script&lang=js"
export * from "./NeedRefreshModal.vue?vue&type=script&lang=js"

import "./NeedRefreshModal.vue?vue&type=style&index=0&id=b70810f6&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__